export const API_URLS = {
  TESTS: '/tests',
  HARD_DELETE: '/tests/hard',
};
